// Lazy-loaded components for better performance
import LoadingSpinner from './LoadingSpinner';
import { lazyLoad } from '../utils/lazyLoad';

// Heavy components that should be loaded on demand with preloading
export const LazyNavbar = lazyLoad(
  () => import(/* webpackChunkName: "navbar" */ './Navbar'),
  <LoadingSpinner />
);

export const LazyGroup = lazyLoad(
  () => import(/* webpackChunkName: "group" */ './group'),
  <LoadingSpinner />
);

export const LazyDefaultGroup = lazyLoad(
  () => import(/* webpackChunkName: "defaultGroup" */ './defaultGroup'),
  <LoadingSpinner />
);

export const LazyGroupTabs = lazyLoad(
  () => import(/* webpackChunkName: "groupTabs" */ './GroupTabs'),
  <LoadingSpinner />
);

export const LazyAuthPage = lazyLoad(
  () => import(/* webpackChunkName: "auth" */ './AuthPage.js'),
  <LoadingSpinner />
);

export const LazyTerms = lazyLoad(
  () => import(/* webpackChunkName: "termsOfService" */ './Terms'),
  <LoadingSpinner />
);

export const LazyPrivacyPolicy = lazyLoad(
  () => import(/* webpackChunkName: "privacyPolicy" */ './PrivacyPolicy'),
  <LoadingSpinner />
);

export const LazyEmailValidation = lazyLoad(
  () =>
    import(/* webpackChunkName: "emailValidation" */ './EmailValidation.js'),
  <LoadingSpinner />
);

export const LazyEmailValidationPending = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "emailValidationPending" */ './EmailValidationPending.js'
    ),
  <LoadingSpinner />
);

export const LazySettingsPage = lazyLoad(
  () => import(/* webpackChunkName: "settings" */ './SettingsPage'),
  <LoadingSpinner />
);

// Preload critical components
export const preloadCriticalComponents = () => {
  // Preload the most commonly used components
  import(/* webpackChunkName: "group" */ './group');
  import(/* webpackChunkName: "groupTabs" */ './GroupTabs');
  import(/* webpackChunkName: "defaultGroup" */ './defaultGroup');
};

// Preload components on idle
if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
  window.requestIdleCallback(
    () => {
      preloadCriticalComponents();
    },
    { timeout: 2000 }
  );
} else {
  // Fallback for browsers without requestIdleCallback
  setTimeout(preloadCriticalComponents, 1000);
}
